import { verifyEmail } from '@uplift/api';
import { useL10n } from '@uplift/hooks';
import { UpliftThemeProvider } from '@uplift/ui-v2';
import { useCallback, useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useHistory, useLocation } from 'react-router';
import { ExpiredEmailVerifyLink } from './expired-email-verify-link.modal';

export const VerifyEmailModal: React.VFC = () => {
  const l10n = useL10n();
  const { search, pathname } = useLocation();
  const [ showExpiredModal, setShowExpiredModal ] = useState(false);
  const snackbar = useAlert();
  const history = useHistory();

  const handleModalClose = useCallback(() => {
    setShowExpiredModal(false);
    snackbar.success(l10n.dashboard.emailVerification.checkYourEmail);
  }, [ l10n.dashboard.emailVerification.checkYourEmail, snackbar ]);

  useEffect(() => {
    const params = new URLSearchParams(search);

    if (!params.get('email_verification_code')) {
      return;
    }

    const runVerify = async (code: string) => {
      try {
        await verifyEmail(code);

        snackbar.success(<span dangerouslySetInnerHTML={{ __html: l10n.dashboard.emailVerification.verified }} />);
        params.delete('email_verification_code');
      } catch (err) {
        if (err.code && err.code === 'ECONNABORTED') {
          return;
        }

        setShowExpiredModal(true);
        params.delete('email_verification_code');
      }
    };

    runVerify(params.get('email_verification_code'));
  }, [ history, l10n.dashboard.emailVerification.verified, pathname, search, snackbar ]);

  if (showExpiredModal) {
    return (
      <UpliftThemeProvider>
        <ExpiredEmailVerifyLink open={showExpiredModal} onClose={handleModalClose} />
      </UpliftThemeProvider>
    );
  }

  return null;
};
